import axios from "axios";

export default () => {
    if (localStorage.gorsh_token) {
        axios.defaults.headers.common["Authorization"] =
            localStorage.gorsh_token;
    }

    return axios.create({
        baseURL: `https://gorsh.net/api/wholesellers`,
        withCredentials: false,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};



// WEBPACK FOOTER //
// ./src/Api/index.js